import React from 'react';
import { Outlet } from 'react-router-dom';
import '../../index.css';


const PublicLayout = () => {
    return (
        <div className='bg-light'>
            <Outlet />
        </div>
    );
}

export default PublicLayout;